<template>
  <BaseConfirmModal v-bind="confirmModal" v-on:confirm="onConfirm">
    <template v-slot:header>
      <h3>Criação de usuário</h3>
    </template>

    <template v-slot:default>
      <p>
        Ainda não existe um usuário no sistema para o servidor
        {{ servidor }}. Deseja criar um usuário para o mesmo?
      </p>
    </template>
  </BaseConfirmModal>
</template>

<script>
export default {
  name: "UsuarioCreationConfirmModal",
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true
    },

    value: Object
  },
  data() {
    return {
      confirmModal: {
        id: this.id
      }
    };
  },
  computed: {
    servidor() {
      return this.value ? `${this.value.nome} (CPF: ${this.value.cpf})` : "";
    }
  },
  methods: {
    onConfirm(event) {
      this.$emit("confirm", event);
    }
  }
};
</script>

<style scoped>
h3 {
  font-size: 2.28rem;
  margin: 1.52rem 0 0.912rem 0;
}
</style>
